import { get } from 'vuex-pathify'

export default {
  computed: {
    ...get({
      userIsAuthenticated: 'auth/isAuthenticated'
    })
  }
}
